import {
  Activity,
  BookOpen,
  Briefcase,
  Building2,
  Coffee,
  Cross,
  Dumbbell,
  Flame,
  Globe,
  GraduationCap,
  Handshake,
  Heart,
  Home,
  Leaf,
  Lightbulb,
  Music,
  Palette,
  Star,
  Sunset,
  Users,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export interface BucketIconDef {
  name: string
  label: string
  Icon: LucideIcon
}

export const BUCKET_ICONS: BucketIconDef[] = [
  { name: 'cross',         label: 'Faith',        Icon: Cross        },
  { name: 'flame',         label: 'Spirit',       Icon: Flame        },
  { name: 'book-open',     label: 'Scripture',    Icon: BookOpen     },
  { name: 'heart',         label: 'Love',         Icon: Heart        },
  { name: 'users',         label: 'Family',       Icon: Users        },
  { name: 'home',          label: 'Home',         Icon: Home         },
  { name: 'briefcase',     label: 'Work',         Icon: Briefcase    },
  { name: 'building-2',    label: 'Career',       Icon: Building2    },
  { name: 'activity',      label: 'Health',       Icon: Activity     },
  { name: 'dumbbell',      label: 'Fitness',      Icon: Dumbbell     },
  { name: 'handshake',     label: 'Service',      Icon: Handshake    },
  { name: 'globe',         label: 'Mission',      Icon: Globe        },
  { name: 'palette',       label: 'Creativity',   Icon: Palette      },
  { name: 'music',         label: 'Music',        Icon: Music        },
  { name: 'coffee',        label: 'Rest',         Icon: Coffee       },
  { name: 'sunset',        label: 'Sabbath',      Icon: Sunset       },
  { name: 'leaf',          label: 'Nature',       Icon: Leaf         },
  { name: 'lightbulb',     label: 'Growth',       Icon: Lightbulb    },
  { name: 'graduation-cap',label: 'Learning',     Icon: GraduationCap},
  { name: 'star',          label: 'Calling',      Icon: Star         },
]

const iconMap = new Map(BUCKET_ICONS.map(d => [d.name, d.Icon]))

export function getBucketIcon(name: string | undefined): LucideIcon | null {
  if (!name) return null
  return iconMap.get(name) ?? null
}
